module.exports = __webpack_public_path__ + "static/media/everyday_digital_paper_190_year.88b41b8b.png";